import {
  defaultDeliveredTo,
  PostCodeCheckResponse,
  TrackingResponse,
  TrackingResponseError
} from './Api';

export enum stageList {
  Sortierzentrum = 'Sortierzentrum',
  ZustellDepot = 'Zustelldepot',
  InZustellung = 'In Zustellung',
  Zugestellt = 'Zugestellt',
  Unzustellbar = 'Unzustellbar'
}

export type stages =
  | stageList.Sortierzentrum
  | stageList.ZustellDepot
  | stageList.InZustellung
  | stageList.Zugestellt
  | stageList.Unzustellbar;

export const defaultStagesOrder: stages[] = [
  stageList.Sortierzentrum,
  stageList.ZustellDepot,
  stageList.InZustellung,
  stageList.Zugestellt
];

export const undeliveredStagesOrder: stages[] = [
  stageList.Sortierzentrum,
  stageList.ZustellDepot,
  stageList.InZustellung,
  stageList.Unzustellbar
];

export const shortStagesOrder: stages[] = [
    stageList.Sortierzentrum,
    stageList.InZustellung
];

export interface IStatusState {
  statuses: TrackingResponse[];
  carrier: string;
  stages: stages[];
  currentStatus: TrackingResponse | null;
  deliveredToDetails: PostCodeCheckResponse;
  error: TrackingResponseError;
}

export const initialStatusState: IStatusState = {
  statuses: [],
  carrier: '',
  stages: defaultStagesOrder,
  currentStatus: null,
  deliveredToDetails: defaultDeliveredTo,
  error: {}
};
